"use client";

import { c as _c } from "react/compiler-runtime";
import { RiFlashlightLine } from "react-icons/ri";
import { cx } from "@/lib/tailwind-utils";
import { useSequences } from "./context";
interface ChipProps {
  className?: string;
}

/**
 * The "⚡ N" chip rendered on the appointment card. Hidden when count is 0
 * unless the surrounding container hovers (which surfaces an add affordance
 * instead — handled by the host card via `<AddButton />`).
 */
export function Chip(t0) {
  const $ = _c(12);
  const {
    className
  } = t0;
  const {
    state: t1
  } = useSequences();
  const {
    drafts
  } = t1;
  const count = drafts.length;
  if (count === 0) {
    return null;
  }
  const t2 = `${count} sequence${count === 1 ? "" : "s"}`;
  let t3;
  if ($[0] !== className) {
    t3 = cx("text-caption flex items-center gap-0.5 border rounded-full px-1.5 py-0.5", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <RiFlashlightLine size={10} className="text-status-warning-text" />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = count === 1 ? "" : "s";
  let t6;
  if ($[3] !== t5) {
    t6 = <span>{t5}</span>;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== count || $[6] !== t6) {
    t7 = <span>{count} message{t6}</span>;
    $[5] = count;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t7) {
    t8 = <span aria-label={t2} className={t3}>{t4}{t7}</span>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}